// extracted by mini-css-extract-plugin
export var logo = "_lw-2";
export var logoWrapper = "_lw-1";
export var strip = "_lw-0";